import * as authApi from "../api/companyService";
import * as targetAccountApi from "../api/targetAccountService";
import { clearListsCache } from "./listUseCase";

export async function postImpactedCompanies(request) {
    return await authApi.postImpactedCompanies(request);
}

export async function postCompaniesLogos(request) {
    return await authApi.postCompaniesLogos(request);
}

export async function postTargetAccounts(request, options = {}) {
    return await authApi.postTargetAccounts(request, options);
}

export async function postRateCompany(request) {
    const result = await targetAccountApi.postRateCompany(request);
    clearListsCache();
    return result;
}

export async function bulkSendToTargetAccounts(request) {
    const result = await targetAccountApi.bulkSendToTargetAccounts(request);
    clearListsCache();
    return result;
}

export async function bulkSendToExclusion(request) {
    const result = await targetAccountApi.bulkSendToExclusion(request);
    clearListsCache();
    return result;
}

export async function bulkSendToTargetAccountsAsync(request) {
    const result = await targetAccountApi.bulkSendToTargetAccountsAsync(request);
    clearListsCache();
    return result;
}

export async function getBulkSendToTargetAccountsStatus(jobId, since = 0) {
    return await targetAccountApi.getBulkSendToTargetAccountsStatus(jobId, since);
}

export async function bulkSendToExclusionAsync(request) {
    return await targetAccountApi.bulkSendToExclusionAsync(request);
}

export async function getBulkSendToExclusionStatus(jobId, since = 0) {
    return await targetAccountApi.getBulkSendToExclusionStatus(jobId, since);
}

export async function deleteCompany(request) {
    const result = await targetAccountApi.deleteCompany(request.linkedinCompanyId);
    clearListsCache();
    return result;
}

export async function addTargetAccount(request) {
    const result = await targetAccountApi.addTargetAccount(request);
    clearListsCache();
    return result;
}

export async function uploadFile(request, config = {}) {
    const result = await targetAccountApi.uploadFile(request, config);
    clearListsCache();
    return result;
}

export async function uploadFileAsync(request, config = {}) {
    const result = await targetAccountApi.uploadFileAsync(request, config);
    return result;
}

export async function getUploadFileStatus(jobId) {
    return await targetAccountApi.getUploadFileStatus(jobId);
}

export async function assignResponsible(request) {
    return await targetAccountApi.assignResponsible(request);
}

export async function uploadContactsFile(request, config = {}) {
    return await targetAccountApi.uploadContactsFile(request, config);
}

export async function uploadContactsFileAsync(request, config = {}) {
    return await targetAccountApi.uploadContactsFileAsync(request, config);
}

export async function getUploadContactsFileStatus(jobId) {
    return await targetAccountApi.getUploadContactsFileStatus(jobId);
}
